import { useMutation } from 'urql';
import { gql } from 'urql';

export const DELETE_EVENT_ORGANIZER_MUTATION = gql`
  mutation ($userId: Int!, $eventId: Int!) {
    deleteEventOrganizer(userId: $userId, eventId: $eventId) {
      rowsAffected
    }
  }
`;

export interface DeleteEventOrganizerVariables {
  userId: number;
  eventId: number;
}

export interface DeleteEventOrganizerResponse {
  deleteEventOrganizer: {
    rowsAffected: number;
  };
}

export const useFetchDeleteEventOrganizer = () => {
  return useMutation<DeleteEventOrganizerResponse, DeleteEventOrganizerVariables>(DELETE_EVENT_ORGANIZER_MUTATION);
};
